import { render, staticRenderFns } from "./informationUp.vue?vue&type=template&id=08feb636&scoped=true"
import script from "./informationUp.vue?vue&type=script&lang=js"
export * from "./informationUp.vue?vue&type=script&lang=js"
import style0 from "./informationUp.vue?vue&type=style&index=0&id=08feb636&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08feb636",
  null
  
)

export default component.exports